// 集成商信息
import { i18n } from '@/common/utils/i18n'
import VueI18n from '@/i18n/locale'
import { get } from 'lodash-es'
function formatIsIntegator(data) {
  const integatorList = new Map([
    [0, '--'],
    [1, i18n.gettext('是')],
    [2, i18n.gettext('否')],
  ])
  if (data) {
    return integatorList.get(data)
  }
  return i18n.gettext('否')
}
export default state => {
  const other = get(state, 'currentShopBaseDetail', {})
  return {
    title: VueI18n.t('FoodB_v12_EuTn_cOWR'),
    content: [
      {
        title: VueI18n.t('FoodB_v12_yorO_qIQQ'),
        content: formatIsIntegator(other.isIntegrator),
      },
      {
        title: VueI18n.t('FoodB_v12_XWfx_gGrQ'),
        content: other.integrator || '--',
      },
      {
        title: VueI18n.t('FoodB_v12_iuCB_kwbr'),
        content: formatIsIntegator(other.isDeliveryIntegrator),
      },
      {
        title: VueI18n.t('FoodB_v12_zpim_qhxP'),
        content: other.deliveryIntegrator || '--',
      },
    ],
  }
}
